import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, Validators } from '@angular/forms';
import { merge } from 'rxjs';
import { timePattern } from '../../../../../validators';
import { MatIconModule } from '@angular/material/icon';
import { PriceDatePickerComponent } from '../../price-date-picker/price-date-picker.component';
import { SharedModule } from '../../../../../shared.module';
import { TranslocoModule } from '@ngneat/transloco';
import { inOutAnimation } from '../../../../../animations';
import { AbstractPricingListDirective } from '../abstract-pricing-list.directive';

@Component({
  selector: 'psc-pricing-list',
  standalone: true,
  imports: [CommonModule, MatIconModule, PriceDatePickerComponent, ReactiveFormsModule, SharedModule, TranslocoModule],
  templateUrl: './pricing-list.component.html',
  animations: [
    inOutAnimation({}),
  ],
})
export class PricingListComponent extends AbstractPricingListDirective implements OnInit {


  ngOnInit() {
    this.addPricing();
  }

  addTimeSlot(index: number) {
    const priceValidators = [Validators.required, Validators.min(0)];
    const group = this.formBuilder.group({
      timeFrom: ['', [Validators.required, Validators.pattern(timePattern)]],
      timeTo: ['', [Validators.required, Validators.pattern(timePattern)]],
      priceKWH: ['', priceValidators],
      priceDistribution: ['', priceValidators],
      priceTransfer: ['', priceValidators],
      priceOIE: ['', priceValidators],
      pricePerPeakPower: ['', priceValidators],
    });
    this.timeSlots(index).push(group);
    this.subs.sink = merge(
      group.controls['timeFrom'].valueChanges,
      group.controls['timeTo'].valueChanges,
    ).subscribe(() => {
      this.upsertPriceErrors.timeslotsAreNotDayError = false;
    });
  }
}

